__turbopack_context__.v({
  "circle": "loader-module__eQ8qba__circle",
  "circle7124": "loader-module__eQ8qba__circle7124",
  "shadow": "loader-module__eQ8qba__shadow",
  "shadow046": "loader-module__eQ8qba__shadow046",
  "wrapper": "loader-module__eQ8qba__wrapper",
});
